// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"2f2caa94","453":"95910ec8"}[chunkId] + ".chunk.js";
};